import { PlatformRole } from "@proto/gen/users/v1/service"

export type ActionId =
  | "admin.section.overview"
  | "admin.section.dispatcher"
  | "admin.section.domain"
  | "admin.section.simulator"
  | "admin.section.optimizer-simulator"
  | "admin.section.fleet"
  | "admin.section.bidding"
  | "admin.section.reports"
  | "admin.section.customers"
  | "admin.section.users"
  | "admin.section.schema-erd"
  | "admin.section.agent"
  | "admin.section.aws-cost-reports"
  | "admin.section.lacework-triage"
  | "admin.section.e2e"
  | "admin.section.docs"
  | "app.customers"
  | "bidding.bid.accept"
  | "bidding.occto.send"
  | "bidding.occto.resend"
  | "bidding.jepx.poll"
  | "bidding.test_servers"
  | "reports.energy.read"
  | "reports.energy.reprocess"
  | "reports.uptime.read"
  | "reports.carbon.read"
  | "reports.sessions.read"

export const ACTION_EXTRA_ROLES = {
  "admin.section.overview": [PlatformRole.GLOBAL_OPS],
  "admin.section.dispatcher": [PlatformRole.GLOBAL_OPS],
  "admin.section.domain": [PlatformRole.GLOBAL_OPS],
  "admin.section.simulator": [PlatformRole.GLOBAL_OPS],
  "admin.section.optimizer-simulator": [PlatformRole.GLOBAL_OPS],
  "admin.section.fleet": [PlatformRole.GLOBAL_OPS],
  "admin.section.bidding": [PlatformRole.TRADER],
  "admin.section.reports": [PlatformRole.TRADER],
  "admin.section.customers": [],
  "admin.section.users": [],
  "admin.section.schema-erd": [],
  "admin.section.agent": [],
  "admin.section.aws-cost-reports": [],
  "admin.section.lacework-triage": [],
  "admin.section.e2e": [],
  "admin.section.docs": [],
  "app.customers": [],
  "bidding.bid.accept": [],
  "bidding.occto.send": [],
  "bidding.occto.resend": [],
  "bidding.jepx.poll": [],
  "bidding.test_servers": [],
  "reports.energy.read": [PlatformRole.TRADER],
  "reports.energy.reprocess": [],
  "reports.uptime.read": [],
  "reports.carbon.read": [],
  "reports.sessions.read": [],
} as const satisfies Record<ActionId, readonly PlatformRole[]>

export function canPerform(role: PlatformRole | undefined, action: ActionId): boolean {
  if (action === "app.customers") return role !== PlatformRole.TRADER
  if (role === PlatformRole.GLOBAL_ADMIN) return true
  if (role === undefined || role === PlatformRole.UNSPECIFIED) return false
  return (ACTION_EXTRA_ROLES[action] as readonly PlatformRole[]).includes(role)
}
